import { render, staticRenderFns } from "./TappeItinerarioViaemilia.vue?vue&type=template&id=5c9127b7&scoped=true&"
import script from "./TappeItinerarioViaemilia.vue?vue&type=script&lang=js&"
export * from "./TappeItinerarioViaemilia.vue?vue&type=script&lang=js&"
import style0 from "./TappeItinerarioViaemilia.vue?vue&type=style&index=0&id=5c9127b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9127b7",
  null
  
)

export default component.exports